import React from 'react';
import { BodyText } from '../typography';
import { ErrorWrapSC } from './balance-alert.styled';
import { FormattedMessage } from 'react-intl';
import dlt from '../../utils/default-lang';

const BalanceAlert = ({ title, description, type, className }) => {
  const textColorClass = type === 'warning' ? 'orange' : 'red';

  if (!title && type !== 'warning') {
    title = <FormattedMessage id="global_alert" defaultMessage={dlt['global_alert']} />;
  }

  return (
    <ErrorWrapSC type={type}  className={className}>
      {title && <BodyText className={`bold ${textColorClass}`}>{title}</BodyText>}
      <BodyText className={`${textColorClass}`}>{description}</BodyText>
    </ErrorWrapSC>
  );
};

export default BalanceAlert;
